import styled from "@emotion/styled"

const ListSixteenItemWrapper = styled.div``

export default ListSixteenItemWrapper
